import React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

const UnlockMsg = ({ anchorEl, open, onClose }) => {
  return (
    <Popover
    
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Typography sx={{ p: 2 }}>New scenes unlocked!</Typography>
    </Popover>
  );
};

export default UnlockMsg;